// Print parts of a screen (a stage record, the stores sheet), each on its own A4 page.
//
// The parts are copied into a temporary #print-root; the print stylesheet (index.css) takes
// the rest of the app out of the page, so it prints the same from a dialog, a tab or a stage
// card. Typed values and ticks are copied too (a cloned input would otherwise print empty).
// Each copy is laid out at the printable width first; if it is taller than the page it is
// scaled down to fit, so a form never spills onto a second sheet. Several parts (the two
// paper pages of one stage) print one per sheet.
const MM = 96 / 25.4; // CSS pixels per millimetre
const PAGE_WIDTH_MM = 210 - 2 * 12; // A4 less the @page margins (index.css)
const PAGE_HEIGHT_PX = Math.floor((297 - 2 * 12) * MM) - 16; // a little slack for rounding

function copyOf(node) {
  const clone = node.cloneNode(true);
  const from = node.querySelectorAll("input, textarea, select");
  const to = clone.querySelectorAll("input, textarea, select");
  from.forEach((el, i) => {
    const c = to[i];
    if (!c) return;
    if (c.tagName === "TEXTAREA") c.textContent = el.value;
    else if (c.tagName === "SELECT") Array.from(c.options).forEach((o, k) => (k === el.selectedIndex ? o.setAttribute("selected", "") : o.removeAttribute("selected")));
    else if (c.type === "checkbox") el.checked ? c.setAttribute("checked", "") : c.removeAttribute("checked");
    else if (["date", "time", "datetime-local"].includes(c.type) && !el.value) c.type = "text"; // an empty one would print "dd-mm-yyyy"
    else c.setAttribute("value", el.value);
  });
  clone.classList.remove("hidden");
  return clone;
}

/** `nodes` is one element, or several (each printed on its own sheet). */
export function printElement(nodes) {
  const list = (nodes instanceof Element ? [nodes] : Array.from(nodes || [])).filter(Boolean);
  if (!list.length) return;

  // Off screen at the page's width, so every page can be measured before it is printed.
  const root = document.createElement("div");
  root.id = "print-root";
  root.style.cssText = `position:absolute;left:-10000px;top:0;width:${PAGE_WIDTH_MM}mm;`;
  list.forEach((node) => {
    const page = document.createElement("div");
    page.className = "print-page";
    page.appendChild(copyOf(node));
    root.appendChild(page);
  });
  document.body.appendChild(root);
  root.querySelectorAll(".print-page").forEach((page) => {
    const height = page.scrollHeight;
    if (height > PAGE_HEIGHT_PX) page.style.zoom = String(PAGE_HEIGHT_PX / height);
  });

  const cleanup = () => {
    root.remove();
    window.removeEventListener("afterprint", cleanup);
  };
  window.addEventListener("afterprint", cleanup);
  window.print();
}
